export default "__VITE_ASSET__BAqXcWZb__"